// import React from 'react';
// import { Award, Calendar, Users2, CheckCircle } from 'lucide-react';
// import { useInView } from 'react-intersection-observer';

// export const About = () => {
//   const { ref, inView } = useInView({
//     threshold: 0.1,
//     triggerOnce: true,
//   });
  
//   const stats = [
//     { icon: <Calendar className="h-8 w-8 text-navy-600" />, value: '25+', label: 'سنوات من الخبرة' },
//     { icon: <Users2 className="h-8 w-8 text-navy-600" />, value: '500+', label: 'عميل راضي' },
//     { icon: <CheckCircle className="h-8 w-8 text-navy-600" />, value: '95%', label: 'نسبة النجاح' },
//     { icon: <Award className="h-8 w-8 text-navy-600" />, value: '50+', label: 'جائزة وتكريم' }
//   ];

//   return (
//     <section id="about" className="py-20 bg-navy-50">
//       <div className="container mx-auto px-4 md:px-6">
//         <div
//           ref={ref}
//           className={`transform transition-all duration-700 ${
//             inView ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
//           }`}
//         >
//           <div className="text-center mb-16">
//             <h2 className="text-3xl md:text-4xl font-bold text-navy-900 mb-4">
              
// عن شركة ناصر الراجحي و  رامي المطيري للمحاماة              
//               </h2>
//             <div className="w-24 h-1 bg-navy-600 mx-auto mb-6"></div>
//           </div>

//           <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
//             <div
//               className={`transition-all duration-700 delay-300 ${
//                 inView ? 'translate-x-0 opacity-100' : 'translate-x-20 opacity-0'
//               }`}
//             >
//               <h3 className="text-2xl font-bold text-navy-900 mb-4">من نحن</h3>
//               <p className="text-gray-700 mb-6 leading-relaxed">
//                 تأسست شركة ناصر الراجحي و رامي المطيري للمحاماة في عام 2016 على يد مجموعة من المحامين ذوي الخبرة والكفاءة. نحن نفخر بأننا أحد الشركات القانونية الرائدة في المنطقة، حيث نقدم خدمات قانونية متميزة بأعلى معايير الجودة والاحترافية.
//               </p>
//               <p className="text-gray-700 mb-6 leading-relaxed">
//                 يضم مكتبنا فريقاً من المحامين المتخصصين في مختلف مجالات القانون، ونسعى دائماً لتحقيق أهداف عملائنا وحماية مصالحهم بكفاءة وفعالية.
//               </p>
              
//               <h3 className="text-2xl font-bold text-navy-900 mb-4">رؤيتنا</h3>
//               <p className="text-gray-700 leading-relaxed">
//                 نسعى لأن نكون الشركة القانونية الرائدة التي توفر حلولاً قانونية مبتكرة تلبي احتياجات العملاء وتتجاوز توقعاتهم، مع الالتزام بأعلى معايير النزاهة والمهنية والتميز في تقديم الخدمات القانونية.
//               </p>
//             </div>
            
//             <div 
//               className={`bg-white p-8 rounded-lg shadow-card transition-all duration-700 delay-500 ${
//                 inView ? 'translate-x-0 opacity-100' : '-translate-x-20 opacity-0'
//               }`}
//             >
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//                 {stats.map((stat, index) => (
//                   <div key={index} className="text-center p-4 border-b-2 border-navy-600 bg-navy-50 rounded-lg transform transition-transform hover:-translate-y-1 duration-300">
//                     <div className="flex justify-center mb-3">{stat.icon}</div>
//                     <div className="text-3xl font-bold text-navy-900 mb-1">{stat.value}</div>
//                     <div className="text-gray-700">{stat.label}</div>
//                   </div>
//                 ))}
//               </div>
              
//               <div className="mt-8 p-6 bg-navy-900 text-white rounded-lg">
//                 <h4 className="text-xl font-bold mb-4 text-navy-300">لماذا تختارنا؟</h4>
//                 <ul className="space-y-3">
//                   <li className="flex items-start">
//                     <span className="text-navy-300 mr-2">✓</span>
//                     <span>فريق من المحامين ذوي الخبرة والكفاءة</span>
//                   </li>
//                   <li className="flex items-start">
//                     <span className="text-navy-300 mr-2">✓</span>
//                     <span>نهج شخصي يركز على احتياجات كل عميل</span>
//                   </li>
//                   <li className="flex items-start">
//                     <span className="text-navy-300 mr-2">✓</span>
//                     <span>تاريخ حافل من النجاح والإنجازات</span>
//                   </li>
//                   <li className="flex items-start">
//                     <span className="text-navy-300 mr-2">✓</span>
//                     <span>خدمات قانونية شاملة بأسعار تنافسية</span>
//                   </li>
//                 </ul>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };


// import React from 'react';
// import { Award, Calendar, Users2, CheckCircle, Check } from 'lucide-react';
// import { useInView } from 'react-intersection-observer';

// export const About = () => {
//   const { ref, inView } = useInView({
//     threshold: 0.1,
//     triggerOnce: true,
//   });
  
//   // الإحصائيات بعد تحديث الألوان وربط الأرقام بصورة واقعية ومهنية من تاريخ التأسيس 2016
//   const stats = [
//     { icon: <Calendar className="h-8 w-8 text-amber-400 group-hover:text-amber-300 transition-colors" />, value: '10+', label: '   سنوات في تقديم خدمات مهنية و احترافية' },
//     { icon: <Users2 className="h-8 w-8 text-amber-400 group-hover:text-amber-300 transition-colors" />, value: '500+', label: 'شراكة وعميل راضٍ' },
//     { icon: <CheckCircle className="h-8 w-8 text-amber-400 group-hover:text-amber-300 transition-colors" />, value: '95%', label: 'معدل نجاح وتسوية القضايا' },
//     { icon: <Award className="h-8 w-8 text-amber-400 group-hover:text-amber-300 transition-colors" />, value: '30+', label: 'جائزة وشراكة استراتيجية' }
//   ];

//   return (
//     <section id="about" className="py-24 bg-slate-950 border-b border-slate-900" dir="rtl">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div
//           ref={ref}
//           className={`transform transition-all duration-1000 ${
//             inView ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
//           }`}
//         >
//           {/* عنوان القسم الرئيسي */}
//           <div className="text-center mb-20">
//             <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-4">
//               عن <span className="text-amber-400">الشركة</span>
//             </h2>
//             <div className="w-20 h-1 bg-gradient-to-r from-amber-500 to-amber-300 mx-auto mb-6 rounded-full"></div>
//           </div>

//           <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            
//             {/* الجانب الأيمن: المحتوى التعريفي والرؤية */}
//             <div
//               className={`transition-all duration-1000 delay-300 transform ${
//                 inView ? 'translate-x-0 opacity-100' : 'translate-x-12 opacity-0'
//               }`}
//             >
//               <div className="space-y-8">
//                 <div>
//                   <h3 className="text-2xl font-bold text-white mb-4 flex items-center gap-2 border-r-4 border-amber-500 pr-3">من نحن</h3>
//                   <p className="text-slate-300 leading-relaxed font-light text-base md:text-lg">
//                     تأسست شركة ناصر الراجحي ورامي المطيري للمحاماة والاستشارات القانونية في عام 2016م على يد نخبة من الكفاءات القانونية المتميزة. ونفخر اليوم بأننا نمثل أحد الكيانات القانونية المهنية الرائدة في المملكة، حيث نلتزم بتقديم الحلول والخدمات القانونية بأعلى معايير الحوكمة والاحترافية الجودة.
//                   </p>
//                   <p className="text-slate-300 mt-4 leading-relaxed font-light text-base md:text-lg">
//                     يضم مكتبنا فريقاً متكاملاً من المحامين والمستشارين المتخصصين في شتى فروع القانون والأنظمة التجارية، لنسير جنباً إلى جنب مع عملائنا لحماية مصالحهم الاستثمارية والمهنية.
//                   </p>
//                 </div>
                
//                 <div>
//                   <h3 className="text-2xl font-bold text-white mb-4 flex items-center gap-2 border-r-4 border-amber-500 pr-3">رؤيتنا</h3>
//                   <p className="text-slate-300 leading-relaxed font-light text-base md:text-lg">
//                     المساهمة الفاعلة في دعم البيئة القانونية والاستثمارية عبر تقديم حلول وابتكارات وقائية وقضائية تتجاوز تطلعات عملائنا، متمسكين بقيم النزاهة المطلقة، السرية، والتميز المهني المستدام.
//                   </p>
//                 </div>
//               </div>
//             </div>
            
//             {/* الجانب الأيسر: الإحصائيات وبطاقة الميزات المدعومة */}
//             <div 
//               className={`transition-all duration-1000 delay-500 transform ${
//                 inView ? 'translate-x-0 opacity-100' : '-translate-x-12 opacity-0'
//               }`}
//             >
//               {/* شبكة أرقام النجاح */}
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
//                 {stats.map((stat, index) => (
//                   <div 
//                     key={index} 
//                     className="group text-center p-6 bg-slate-900 border border-slate-800/80 rounded-2xl transform transition-all duration-300 hover:-translate-y-1 hover:border-amber-500/20"
//                   >
//                     <div className="flex justify-center mb-4">{stat.icon}</div>
//                     <div className="text-3xl md:text-4xl font-extrabold text-white mb-1.5 font-mono">{stat.value}</div>
//                     <div className="text-slate-400 text-sm font-medium">{stat.label}</div>
//                   </div>
//                 ))}
//               </div>
              
//               {/* بطاقة المزايا الحصرية التنافسية */}
//               <div className="p-8 bg-slate-900 border border-slate-800 rounded-2xl relative overflow-hidden group">
//                 <div className="absolute top-0 right-0 w-24 h-24 bg-amber-500/5 rounded-bl-full pointer-events-none transition-all duration-500 group-hover:scale-150"></div>
                
//                 <h4 className="text-xl font-bold mb-6 text-amber-400">لماذا تختار شركتنا؟</h4>
//                 <ul className="space-y-4">
//                   <li className="flex items-start gap-3 text-slate-300 text-sm md:text-base">
//                     <div className="mt-1 flex items-center justify-center p-0.5 rounded-full bg-amber-500/10 text-amber-400 shrink-0">
//                       <Check className="w-4 h-4" />
//                     </div>
//                     <span>فريق متمرس من المحامين ذوي الخبرة والموثوقية العالية.</span>
//                   </li>
//                   <li className="flex items-start gap-3 text-slate-300 text-sm md:text-base">
//                     <div className="mt-1 flex items-center justify-center p-0.5 rounded-full bg-amber-500/10 text-amber-400 shrink-0">
//                       <Check className="w-4 h-4" />
//                     </div>
//                     <span>نهج وقائي استباقي يركز على متطلبات بيئة الأعمال والشركات.</span>
//                   </li>
//                   <li className="flex items-start gap-3 text-slate-300 text-sm md:text-base">
//                     <div className="mt-1 flex items-center justify-center p-0.5 rounded-full bg-amber-500/10 text-amber-400 shrink-0">
//                       <Check className="w-4 h-4" />
//                     </div>
//                     <span>سجل حافل بالإنجازات، وتسوية القضايا المعقدة بنجاح.</span>
//                   </li>
//                   <li className="flex items-start gap-3 text-slate-300 text-sm md:text-base">
//                     <div className="mt-1 flex items-center justify-center p-0.5 rounded-full bg-amber-500/10 text-amber-400 shrink-0">
//                       <Check className="w-4 h-4" />
//                     </div>
//                     <span>منظومة خدمات قانونية شاملة وحلول مبتكرة تغطي كافة احتياجاتكم.</span>
//                   </li>
//                 </ul>
//               </div>

//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };




import React from 'react';
import { Award, Calendar, Users2, CheckCircle, Check } from 'lucide-react';
import { useInView } from 'react-intersection-observer';

export const About = () => {
  const { ref, inView } = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });
  
  // الإحصائيات بعد تحديث الألوان للنمط الكحلي المهني الرصين
  const stats = [
    { icon: <Calendar className="h-8 w-8 text-indigo-950 group-hover:text-blue-700 transition-colors" />, value: '10+', label: 'سنوات في تقديم خدمات مهنية واحترافية' },
    { icon: <Users2 className="h-8 w-8 text-indigo-950 group-hover:text-blue-700 transition-colors" />, value: '500+', label: 'شراكة وعميل راضٍ' },
    { icon: <CheckCircle className="h-8 w-8 text-indigo-950 group-hover:text-blue-700 transition-colors" />, value: '95%', label: 'معدل نجاح وتسوية القضايا' },
    { icon: <Award className="h-8 w-8 text-indigo-950 group-hover:text-blue-700 transition-colors" />, value: '30+', label: 'جائزة وشراكة استراتيجية' }
  ];

  return (
    // ضبط الخلفية لتكون بيضاء ناصعة ومريحة للعين في الوضع الفاتح
    <section id="about" className="py-24 bg-white border-b border-slate-100" dir="rtl">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div
          ref={ref}
          className={`transform transition-all duration-1000 ${
            inView ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
          }`}
        >
          {/* عنوان القسم الرئيسي المنسق باللون الكحلي الفخم */}
          <div className="text-center mb-20">
            <h2 className="text-3xl md:text-5xl font-extrabold text-slate-900 mb-4">
              عن <span className="text-indigo-950">الشركة</span>
            </h2>
            <div className="w-20 h-1 bg-gradient-to-r from-indigo-950 to-blue-500 mx-auto mb-6 rounded-full"></div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            
            {/*الجانب الايمن  */}
            <div
              className={`transition-all duration-1000 delay-300 transform ${
                inView ? 'translate-x-0 opacity-100' : 'translate-x-12 opacity-0'
              }`}
            >
              <div className="space-y-8">
                <div>
                  <h3 className="text-2xl font-bold text-slate-900 mb-4 flex items-center gap-2 border-r-4 border-indigo-950 pr-3">من نحن</h3>
                  <p className="text-black leading-relaxed font-light text-base md:text-lg     ">
                    تأسست شركة ناصر الراجحي ورامي المطيري للمحاماة والاستشارات القانونية في عام 2016م على يد نخبة من الكفاءات القانونية المتميزة. ونفخر اليوم بأننا نمثل أحد الكيانات القانونية المهنية الرائدة في المملكة، حيث نلتزم بتقديم الحلول والخدمات القانونية بأعلى معايير الحوكمة والاحترافية والجودة.
                  </p>
                  <p className="text-black mt-4 leading-relaxed font-light text-base md:text-lg">
                    يضم مكتبنا فريقاً متكاملاً من المحامين والمستشارين المتخصصين في شتى فروع القانون والأنظمة التجارية، لنسير جنباً إلى جنب مع عملائنا لحماية مصالحهم الاستثمارية والمهنية.
                  </p>
                </div>
                
                <div>
                  <h3 className="text-2xl font-bold text-slate-900 mb-4 flex items-center gap-2 border-r-4 border-indigo-950 pr-3">رؤيتنا</h3>
                  <p className="text-black leading-relaxed font-light text-base md:text-lg">
                    المساهمة الفاعلة في دعم البيئة القانونية والاستثمارية عبر تقديم حلول وابتكارات وقائية وقضائية تتجاوز تطلعات عملائنا، متمسكين بقيم النزاهة المطلقة، السرية، والتميز المهني المستدام.
                  </p>
                </div>
              </div>
            </div>
            
            {/* الجانب الأيسر: الإحصائيات ح */}
            <div 
              className={`transition-all duration-1000 delay-500 transform ${
                inView ? 'translate-x-0 opacity-100' : '-translate-x-12 opacity-0'
              }`}
            >
              {/* شبكة أرقام النجاح بخلفيات رمادية خفيفة ناعمة ونصوص واضحة */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                {stats.map((stat, index) => (
                  <div 
                    key={index} 
                    className="group text-center p-6 bg-slate-50 border border-slate-100 rounded-2xl transform transition-all duration-300 hover:-translate-y-1 hover:border-indigo-950/10 hover:bg-white hover:shadow-lg hover:shadow-slate-100"
                  >
                    <div className="flex justify-center mb-4">{stat.icon}</div>
                    <div className="text-3xl md:text-4xl font-extrabold text-indigo-950 mb-1.5 font-mono">{stat.value}</div>
                    <div className="text-black-500 text-sm font-medium">{stat.label}</div>
                  </div>
                ))}
              </div>
              
              {/* بطاقة المزايا الحصرية المتناسقة تماماً مع الـ Navy */}
              <div className="p-8 bg-slate-50 border border-slate-100 rounded-2xl relative overflow-hidden group">
                <div className="absolute top-0 right-0 w-24 h-24 bg-indigo-950/5 rounded-bl-full pointer-events-none transition-all duration-500 group-hover:scale-150"></div>
                
                <h4 className="text-xl font-bold mb-6 text-indigo-950">لماذا تختار شركتنا؟</h4>
                <ul className="space-y-4">
                  <li className="flex items-start gap-3 text-black text-sm md:text-base">
                    <div className="mt-1 flex items-center justify-center p-0.5 rounded-full bg-indigo-50 text-indigo-950 shrink-0">
                      <Check className="w-4 h-4" />
                    </div>
                    <span>فريق متمرس من المحامين ذوي الخبرة والموثوقية العالية.</span>
                  </li>
                  <li className="flex items-start gap-3 text-black text-sm md:text-base">
                    <div className="mt-1 flex items-center justify-center p-0.5 rounded-full bg-indigo-50 text-indigo-950 shrink-0">
                      <Check className="w-4 h-4" />
                    </div>
                    <span>نهج وقائي استباقي يركز على متطلبات بيئة الأعمال والشركات.</span>
                  </li>
                  <li className="flex items-start gap-3 text-black text-sm md:text-base">
                    <div className="mt-1 flex items-center justify-center p-0.5 rounded-full bg-indigo-50 text-indigo-950 shrink-0">
                      <Check className="w-4 h-4" />
                    </div>
                    <span>سجل حافل بالإنجازات، وتسوية القضايا المعقدة بنجاح.</span>
                  </li>
                  <li className="flex items-start gap-3 text-black text-sm md:text-base">
                    <div className="mt-1 flex items-center justify-center p-0.5 rounded-full bg-indigo-50 text-indigo-950 shrink-0">
                      <Check className="w-4 h-4" />
                    </div>
                    <span>منظومة خدمات قانونية شاملة وحلول مبتكرة تغطي كافة احتياجاتكم.</span>
                  </li>
                </ul>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
};